import { Pipe, PipeTransform } from '@angular/core';
import { AssetService } from '../models/assetservice.class';

@Pipe({
    name: 'SortAssets',
    pure: true,
    standalone: false,
})
export class SortassetsPipe implements PipeTransform {
    transform(assets: AssetService[]): any {
        const sortedAssets =
            assets &&
            assets.sort((a, b) => {
                if (a.displayName < b.displayName) {
                    return -1;
                } else if (a.displayName > b.displayName) {
                    return 1;
                }
                return 0;
            });
        return sortedAssets;
    }
}
